export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12117.ec3d7234.jpg";